
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/ai/ui/freeTextInput/freeTextInput.scss.css.virtualfile';
        module.exports = {"input":"_input_1uoze_7"};